import { supabase } from "./supabase";
import { arrivedFromUnreachableServer } from "./session-lib";

// On the login/register pages: a logged-in user has no reason to see the form.
// Except when the app sent them here because the auth server could not be
// reached: the session is still stored, and going back would loop for as long
// as the outage lasts (#442). The login page says why it stayed.
if (!arrivedFromUnreachableServer(window.location.search)) {
  void supabase.auth.getSession().then(({ data }) => {
    if (data.session) {
      window.location.href = "/app/";
    }
  });
}
